export enum Rights {
    FULL_ACCESS = 'portal:full_access',
    PROFILE_READ = 'portal:main_read',
    // METERS_READ = 'portal:meters_read',
    SERVICES_READ = 'portal:services_read',
    SETTINGS_READ = 'portal:settings_read'
}
